import { ComponentsOverrides, ComponentsProps, ComponentsVariants, CssVarsTheme } from '@mui/material/styles';

export const MuiFormLabel: {
  defaultProps?: ComponentsProps['MuiFormLabel'];
  styleOverrides?: ComponentsOverrides<CssVarsTheme>['MuiFormLabel'];
  variants?: ComponentsVariants['MuiFormLabel'];
} = {
  defaultProps: {},
  styleOverrides: {
    root: ({ theme }) => ({
      color: theme.vars.palette.neutral.main,
      ...theme.typography.body2,
      fontWeight: theme.typography.fontWeightMedium
    }),
    asterisk: ({ theme }) => ({
      color: theme.vars.palette.error.main
    })
  }
};
